export type StoredAuthType = 'password' | 'accessCode';

// We surface only two user-facing buckets plus a "none" fallback. The Capgo
// plugin returns finer-grained types (touch id, fingerprint, iris, multi, face
// auth) but the UI doesn't need to disambiguate: Android fingerprint / iris /
// multi all read as "Touch ID" with a fingerprint glyph; iOS Touch ID does too;
// only iOS Face ID and Android face authentication map to "Face ID".
export enum BiometryLabel {
  FaceId = 'faceId',
  TouchId = 'touchId',
  None = 'none',
}

export interface BiometricAvailability {
  available: boolean;
  biometryType: BiometryLabel;
}

// Plain credential pair as the bridge sees it. The auth-type discriminator
// (password vs accessCode) is not the bridge's concern; the hook layer keeps
// it in Capacitor Preferences alongside the Keychain entry.
export interface RawCreds {
  email: string;
  secret: string;
}

export interface BiometricPluginCompat {
  isAvailable: () => Promise<BiometricAvailability>;
  prompt: (reason: string) => Promise<void>;
  setCredentials: (creds: RawCreds) => Promise<void>;
  getCredentials: (reason: string) => Promise<RawCreds>;
  deleteCredentials: () => Promise<void>;
}
